import { render, staticRenderFns } from "./single_hospital.vue?vue&type=template&id=08c17a31&scoped=true"
import script from "./single_hospital.vue?vue&type=script&lang=js"
export * from "./single_hospital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c17a31",
  null
  
)

export default component.exports